import qs from 'qs';

const Staff = {
    namespaced: true,

    state: {
        staffData: [],
    },

    getters: {
        staffData (state) {
            return state.staffData;
        },
    },

    mutations: {
        /**
         * Установить список Ставок (рабочих мест)
         * @param state
         * @param items
         */
        setArr (state, { items }) {
            state['staffData'] = items;
        },

        /**
         * Обновить Ставку (рабочее место)
         * @param state
         * @param item
         * @param index
         */
        setItem (state, { item, index }) {
            state['staffData'][index] = item;
        },

        /**
         * Добавить Ставку (рабочее место)
         * @param state
         * @param item
         */
        addItem (state, { item }) {
            state['staffData'].push(item);
        },

        /**
         * Удалить Ставку (рабочее место)
         * @param state
         * @param item
         */
        remove (state, { item }) {
            state['staffData'] = state['staffData'].filter(iItem => iItem !== item);
        },
    },

    actions: {
        /**
         * Получение данных о ставках
         * @param commit
         * @returns {Promise<any>}
         */
        getStaffData ({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.staffs,
                    }),
                })
                .then(response => (
                    commit('setArr', {
                        type: 'staffData',
                        items: response.data.map(item => {
                            return {
                                id: item.id,
                                pgName: item.pgName,
                                positionId: item.positionId,
                                roleKeyList: !!item.roleKeyList ? item.roleKeyList.split(',') : [],
                                managerId: item.managerId,
                                cityIdList: !!item.cityIdList ? item.cityIdList.split(',') : [],
                                targetFrequencyIncrement: item.targetFrequencyIncrement,
                                promoCode: item.promoCode,
                                extId: item.extId,
                                isActive: item.isActive,
                                userStatus: item.userStatus,
                                isTest: item.isTest
                            }
                        })
                    }),

                    dispatch('loading/isLoading', false, {root:true}),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные о ставках получены!'),
                    resolve()
                ))
                .catch(err => {
                    dispatch('loading/isLoading', false, {root:true});

                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при получении данных о ставках!'),
                    console.log('ERROR IN staff.js | getStaffData: ' + err);
                    reject(err);
                });
            })
        },

        /**
         * Сохранение данных о ставке
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        saveStaffData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify({
                    id: data.data.id,
                    pgName: data.data.pgName,
                    positionId: data.data.positionId,
                    roleKeyList: data.data.roleKeyList.join(','),
                    managerId: data.data.managerId,
                    cityIdList: data.data.cityIdList.join(','),
                    targetFrequencyIncrement: data.data.targetFrequencyIncrement,
                    promoCode: data.data.promoCode,
                    extId: data.data.extId,
                    isActive: data.data.isActive,
                    userStatus: data.data.userStatus,
                    isTest: data.data.isTest,
                });

                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.staffs,
                    }),
                }).then(response => {
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, {root:true});
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные о ставке успешно отредактированы!');
                    // Если создание нового
                    } else {
                        commit('addItem', {
                            item: data.data
                        });

                        dispatch('loading/isLoading', false, {root:true});

                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новая ставка успешно создана!');
                    }

                    resolve();
                })
                .catch(err => {
                    dispatch('loading/isLoading', false, {root:true});

                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                    console.log('ERROR IN staff.js | saveStaffData: ' + err);
                    reject(err);
                });
            })
        },

        /**
         * Удаление данных о ставке
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removeStaffData ({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, {root:true});

                const str = JSON.stringify(data.item);

                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.staffs,
                    }),
                })
                .then(response => {
                    // commit('remove', {
                    //     type: 'staffData',
                    //     item: data.item
                    // }),
                    dispatch('loading/isLoading', false, {root: true});

                    // window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Ставка успешно удалена!'),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'В данный момент ставка не может быть удалена!');

                    resolve();
                })
                .catch(err => {
                    dispatch('loading/isLoading', false, {root:true});

                    //window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении ставки!'),
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'В данный момент ставка не может быть удалена!'),

                    console.log('ERROR IN staff.js | removeRoleData : ' + err);

                    reject(err);
                });
            })
        },
    },
};

export default Staff;


// WEBPACK FOOTER //
// ./src/store/modules/staff.js